module.exports = __webpack_public_path__ + "img/local-acquiring.24697a7.png";